"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
OutletService.$inject = ['api'];
function OutletService(api) {
}
exports.OutletService = OutletService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/services/outlet.js
// module id = 381
// module chunks = 0